import { isNil } from 'lodash';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';
import { EnhancedPlan } from '@mm/state/interfaces/subscription';

type GetPriceByLevelParams = {
  plansAllotments: {
    id: number;
    name: string;
    level: number;
  };
  subscription: SubscriptionModel;
  plan: EnhancedPlan;
  futurePaymentCredits?: number;
};

export const getPriceByLevel = (params: GetPriceByLevelParams) => {
  const { plansAllotments, subscription, plan, futurePaymentCredits } = params;
  const { name, level } = plansAllotments;

  const {
    sendAllotmentAddOnPrice = 0,
    userSeatsAddOnPrice,
    smsNumberAddOnPrice,
  } = plan;

  const {
    maxSendAllotment = 0,
    unitAmountInCents = 0,
    sendAllotmentLevel = 0,
    userSeats,
    extraUserSeats,
    smsNumbers,
    basePrice,
  } = subscription;

  const currentSendCreditsPrice = sendAllotmentLevel * sendAllotmentAddOnPrice;

  const newSendCreditsPrice = sendAllotmentAddOnPrice * level;
  const currentUserSeatsValue = isNil(userSeats) ? -1 : userSeats;
  const currentUserSeatsPrice =
    (userSeatsAddOnPrice || 0) * (extraUserSeats || 0);

  const currentMonthlyFee = unitAmountInCents / 100;

  const smsNumberCount = smsNumbers
    ? Object.values(smsNumbers).filter(Boolean).length
    : 0;
  const currentSmsNumberPrice = smsNumberAddOnPrice
    ? smsNumberCount * smsNumberAddOnPrice
    : 0;

  const newMonthlyFee =
    plan.unitAmountInCents / 100 +
    currentUserSeatsPrice +
    newSendCreditsPrice +
    currentSmsNumberPrice;

  const payNow =
    currentSendCreditsPrice > newSendCreditsPrice
      ? 0
      : newSendCreditsPrice - currentSendCreditsPrice;

  return {
    planPrice: basePrice,
    newSendCreditsValue: Number(name) || null,
    currentSendCreditsValue: maxSendAllotment,
    currentMonthlyFee,
    currentSendCreditsPrice,
    currentUserSeatsValue,
    currentUserSeatsPrice: null,
    newUserSeatsPrice: currentUserSeatsPrice,
    newUserSeatsValue: null,
    newSendCreditsPrice,
    newMonthlyFee,
    payNow,
    smsNumberCount,
    currentSmsNumberPrice: null,
    newSmsNumberPrice: currentSmsNumberPrice,
    newSmsNumberCount: null,
    proRatedAmount: null,
    proRatedAsCredit: futurePaymentCredits,
    showAddCoupon: false,
    futurePaymentCredits,
  };
};
